module.exports = {
      id: "bondhushava-usage",
      viewBox: "0 0 225 61",
      url: "/" + "svg-sprite-21c17c4d458cf2e2be6dd4c01f9ab03b.svg#bondhushava",
      toString: function () {
        return this.url;
      }
    }